import styled from 'styled-components';

export const ArticlePageContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  gap: 26px;
  margin: 0 auto;
  margin-bottom: 32px;
  margin-top: 29px;
  max-width: 1400px;
  width: 100%;

  @media (max-width: 799px) {
    flex-direction: column;
    gap: 20px;
  }
`;

export const MainContent = styled.div`
  flex: 1;
  min-width: 0;
`;

export const ArticleGrid = styled.div`
  display: grid;
  gap: 27px;
  grid-template-columns: repeat(3, 1fr);

  @media (max-width: 1159px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 559px) {
    grid-template-columns: 1fr;
  }
`;
